import React, { useState, useEffect, useRef } from "react";
import { doSignOut } from "../../firebase/auth";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { profileImageState } from "../../Recoil/atoms";
import { useAuth } from "../../firebase/authContext"; // Add auth context to get current user

const settings = ["Profile", "Dashboard", "Logout"];

function ProfileIcon() {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const menuRef = useRef(null);
  const imageUrl = useRecoilValue(profileImageState);
  const { currentUser } = useAuth(); // Get current user from context
  const navigate = useNavigate();

  const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
  const handleCloseUserMenu = () => setAnchorElUser(null);

  const handleSettingClick = (setting) => {
    switch (setting) {
      case "Profile":
        navigate("/profile/" + currentUser.uid);
        break;
      case "Logout":
        doSignOut();
        break;
      default:
        break;
    }
    handleCloseUserMenu();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        handleCloseUserMenu();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block">
      <button
        onClick={handleOpenUserMenu}
        className="focus:outline-none flex items-center"
      >
        <img
          className="w-10 h-10 rounded-full"
          src={currentUser?.photoURL || imageUrl || "/default-avatar.png"}
          alt="User Avatar"
        />
        {currentUser?.displayName && (
          <span className="ml-2 font-semibold text-gray-800">
            {currentUser.displayName}
          </span>
        )}
      </button>
      {anchorElUser && (
        <div
          ref={menuRef}
          className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="user-menu"
        >
          {settings.map((setting) => (
            <button
              key={setting}
              onClick={() => handleSettingClick(setting)}
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left hover:shadow-md rounded-none"
            >
              {setting}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ProfileIcon;
